import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string, boolean, number, any } from "@altostra/type-validations/lib/primitives";

export const isEngagementLandingPageTemplatesDataIdResult = objectOf({
  id: string,
  name: string,
  description: string,
  marked_as_deleted: boolean,
  last_edited_at: number,
  created_by: string,
  last_edited_by: string,
  last_edited_info: objectOf({
    d_id: string,
    name: string,
    time: number,
  }),
  created_by_info: objectOf({
    d_id: string,
    name: string,
    time: number,
  }),
  grapes_js_data: maybe(any, true),
  derived_landing_page_id: maybe(string, true),
  tag_names: arrayOf(string),
  territory_ids: arrayOf(string),
  html: maybe(any, true),
  profile_type: number,
});
